import { mkdir } from 'node:fs/promises';
import { join } from 'node:path';
import type { AuthState } from '@wix/cli-auth';
import { syncRevisionTypes } from '@wix/velo-site-types-syncer';
import { writeJson } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';
import type { ProjectModel } from '../model.js';

export async function syncTypesWithAuth(
  model: ProjectModel,
  opts: {
    authState: AuthState;
  }
) {
  try {
    const accessToken = await opts.authState.getAccessToken();
    await syncRevisionTypes(model, { getAppToken: () => accessToken });

    // TODO: this is temporarily here, will remove (netanelg@wix.com)
    await mkdir(join(model.projectFolder, '.vscode/'), { recursive: true });
    await writeJson(join(model.projectFolder, '.vscode/settings.json'), {
      'files.associations': {
        '*.jsw': 'javascript',
      },
    });
  } catch (e) {
    throw new CliError({
      code: CliErrorCode.FailedToSyncToRevision({ revision: model.revision }),
      cause: e,
      info: { model },
    });
  }
}
